import axios from 'axios'
import appData from '@/helpers/app-data'
import airbrake from '@/helpers/airbrake'

const state = {
  // Includes all service types, including service type groups (parents)
  allServiceTypes: appData.get('all_service_types') || [],
  loading: false,
  error: null
}

const getters = {}

const mutations = {
  SET_SERVICE_TYPES (state, serviceTypes) {
    state.allServiceTypes = serviceTypes
  },
  LOADING (state) {
    state.loading = true
  },
  DONE (state) {
    state.loading = false
  },
  SET_ERROR (state, error) {
    state.error = error
  }
}

const actions = {
  getAllServiceTypes ({commit}) {
    commit('LOADING')
    return axios.get('/list/service_type_groups')
      .then((response) => {
        commit('SET_SERVICE_TYPES', response.data)
        commit('DONE')
      })
      .catch(error => {
        commit('SET_ERROR', error)
        commit('DONE')
        airbrake.notify(error)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/serviceTypes/index.js